// @ts-nocheck
import React from 'react';
import axios from 'axios';
import uuid from 'uuid';
import CryptoJS from 'crypto-js';
import {Utils} from '../../../utils/Globals';
class SaveToLibraryManager {
	fetchLibraries = () => {
		let libs = [];
		const getLibraries = (start = 0, resolve, reject) => {
			if (window.adobeIMS.isSignedInUser() === undefined) {
				reject('User not signed in');
				return;
			}
			let libUrl = window.CONFIG.SERVICES.cclibrary.melville;
			const accessToken = `Bearer ${window.adobeIMS.getAccessToken()}`;
			const header = {
				Authorization: accessToken,
				'x-api-key': 'CCHomeWeb1',
			};
			libUrl = `${libUrl}?orderBy=name&start=${start}&limit=10&owner=private,incoming&selector=default&toolkit=none&team=none`;
			axios
				.get(libUrl, {
					headers: header,
				})
				.then((resp) => {
					if (resp.data.libraries.length === 0) {
						resolve(libs);
						// new user
					}
					else {
						libs = [...libs, ...resp.data.libraries];
						if (start + resp.data.libraries.length < resp.data.total_count) {
							getLibraries(start + 10, resolve, reject);
						}
						else {
							resolve(libs);
							// means done fetching all the libraries
						}
					}
				})
				.catch((err) => {
					reject(err); // failed to fetch libraries
				});
		};

		return new Promise((resolve, reject) => {
			getLibraries(0, resolve, reject);
		});
	};

	addNewLibrary = () => new Promise((resolve, reject) => {
		const name = Utils.localizedStrings['ccx.quickTask.libraryName'];
		let libUrl = window.CONFIG.SERVICES.cclibrary.melville;
		const accessToken = `Bearer ${window.adobeIMS.getAccessToken()}`;
		const header = {
			Authorization: accessToken,
			'x-api-key': 'CCHomeWeb1',
		};
		libUrl = `${libUrl}?invocation_mode=sync`;
		axios
			.post(
				libUrl,
				{name},
				{
					headers: header,
				},
			)
			.then((resp) => {
				resolve([{...resp.data, ownership: 'private'}]);
			})
			.catch((err) => {
				reject(err);
			});
	});

	validateLibCreation = urn => new Promise((resolve, reject) => {
		const libUrl = `${window.CONFIG.SERVICES.cclibrary.melville}/${urn}`;
		const accessToken = `Bearer ${window.adobeIMS.getAccessToken()}`;
		const header = {
			Authorization: accessToken,
			'x-api-key': 'CCHomeWeb1',
		};
		axios
			.get(libUrl, {headers: header})
			.then((resp) => {
				resolve(resp);
			})
			.catch((err) => {
				reject(err);
			});
	});

	addSmallImageAssettoLibrary = params => new Promise((resolve, reject) => {
		let libUrl = window.CONFIG.SERVICES.cclibrary.melville;
		if (params.libtype === 'public') {
			libUrl = `${libUrl}/${params.libID}`;
		}
		else {
			libUrl = `${libUrl}/${params.libURN}`;
		}
		const elementsUrl = `${libUrl}/elements`;
		libUrl = `${libUrl}/representations/content`;

		const accessToken = `Bearer ${window.adobeIMS.getAccessToken()}`;
		const header = {
			Authorization: accessToken,
			'x-api-key': 'CCHomeWeb1',
		};
		const data = new FormData();
		data.set('Representation-Data', `{"type": "${params.format}"}`);
		data.set('Representation-Content', params.asset);
		axios
			.post(libUrl, data, {
				headers: header,
			})
			.then((resp) => {
				let name = resp.data.name;
				if (Utils.mimeTypeToExt && Utils.mimeTypeToExt[params.format].ext) {
					name = `${name}.${Utils.mimeTypeToExt[params.format].ext}`;
				}
				const elementData = {
					name: `${params.filename}`,
					type: 'application/vnd.adobe.element.image+dcx',
					representations: [{...resp.data, name}],
					client: {deviceId: '-', device: '-', app: 'Quick-Actions-CCH'},
				};
				axios
					.post(elementsUrl, elementData, {headers: header})
					.then((resp) => {
						resolve();
					})
					.catch((err) => {
						reject(err);
					});
			})
			.catch((err) => {
				reject(err);
			});
	});

	splitFile(file, handleChunkSuccess) {
		const fileSize = file.size;
		const chunkSize = 5242880;
		const readChunk = (offsetParam, length, resolve, reject) => {
			let offset = offsetParam;
			// This will try creating a chunk ------- step2
			const reader = new FileReader();
			const blob = file.slice(offset, length + offset);

			reader.onload = (evt) => {
				// we test if the chunk creation was successfull ------- step3
				if (evt.target.error == null) {
					offset += evt.target.result.byteLength;
					// Chunk creation successfull
					handleChunkSuccess(evt.target.result);
				}
				else {
					// Chunk creation failed
					reject(evt.target.error);
					return;
				}
				if (offset >= fileSize) {
					// All chunks are created succcessfully
					resolve(file);
					return;
				}
				// We move onto the next chunk ------- step4
				readChunk(offset, chunkSize, resolve, reject);
			};

			reader.readAsArrayBuffer(blob);
		};
		// code will start execution from here ------- step1
		return new Promise((resolve, reject) => {
			readChunk(0, chunkSize, resolve, reject);
		});
	}

	addLargeImageAssettoLibrary = (file, libID, libURN, libtype, format, filename) => {
		const fileChunks = [];
		let md5 = CryptoJS.algo.MD5.create();
		const libUrl = window.CONFIG.SERVICES.cclibrary.asimov;

		const handleChunkSuccess = (chunk) => {
			fileChunks.push(chunk);
			const wordArray = CryptoJS.lib.WordArray.create(chunk);
			md5.update(wordArray);
		};

		return new Promise((resolve, reject) => {
			// waiting for the file to split successfully
			this.splitFile(file, handleChunkSuccess)
				.then(() => {
					const asset = file;
					const newFileName = uuid.v4();
					const hash = md5.finalize();
					md5 = hash.toString(CryptoJS.enc.Base64);
					const accessToken = `Bearer ${window.adobeIMS.getAccessToken()}`;
					const header = {
						Authorization: accessToken,
						'x-api-key': 'CCHomeWeb1',
						'Content-Type': 'application/json',
					};
					const elementData = {
						composite: libID,
						filename: newFileName,
						contentType: asset.type,
						contentLength: asset.size,
						md5,
					};
					// Initialing the uploads call
					axios
						.post(libUrl, elementData, {
							headers: header,
						})
						.then((resp) => {
							const jobID = resp.data.id;
							const promises = [];
							let partNumber = 0;
							// for each chunk creating a promise and inserting it into a promises an array
							fileChunks.forEach((chunk) => {
								partNumber++;
								const data = new FormData();
								const uploadURL = `${libUrl}/${jobID}`;
								data.append(
									'uploadPartRequest',
									new Blob([`{"partNumber":${partNumber},"partSize":${chunk.byteLength}}`], {
										type: 'application/json',
									}),
								);
								data.append('file', new File([chunk], filename, {type: 'application/octet-stream'}));
								promises.push(
									axios.put(uploadURL, data, {
										headers: {
											...header,
											'Content-Type': 'multipart/form-data',
										},
									}),
								);
							});
							// Waiting for all the chunks to be uploaded successfully
							Promise.all(promises)
								.then((resp) => {
									// making the finalize call will return the status as 'UPLOAD_COMPLETE' or "VERIFYING"
									axios({
										method: 'post',
										url: `${libUrl}/${jobID}/finalize`,
										headers: header,
									})
										.then(async(resp) => {
											const elementData = {
												name: filename,
												type: 'application/vnd.adobe.element.image+dcx',
												representations: [
													{
														content_length: resp.data.contentLength,
														md5: resp.data.md5,
														name: resp.data.filename,
														storage_href: `${resp.data.path};version=0`,
														type: resp.data.contentType,
														version: 0,
													},
												],
												client: {deviceId: '-', device: '-', app: '-'},
											};
											if (resp.data.status === 'UPLOAD_COMPLETE') {
												// successfull so make the final elements call
												elementData.representations[0].asset_id = resp.data.fileDetails.urn;
												elementData.representations[0].etag = resp.data.fileDetails.etag;
												elementData.representations[0].id = resp.data.fileDetails.id;
												axios
													.post(
														`${window.CONFIG.SERVICES.cclibrary.melville
														}/${
															libURN
														}/elements`,
														elementData,
														{headers: header},
													)
													.then(() => {
														resolve();
													})
													.catch((err) => {
														reject(err);
													});
											}
											else {
												// we will try to check the status via this call 10 times
												let i = 0;
												for (i = 0; i < 10; i++) {
													const result = await axios({
														method: 'get',
														url: `${libUrl}/${jobID}/finalize`,
														headers: header,
													}).catch((err) => {
														reject(err);
													});
													if (result.data.status === 'UPLOAD_COMPLETE') {
														// successfull so make the final elements call
														elementData.representations[0].asset_id
															= result.data.fileDetails.urn;
														elementData.representations[0].etag
															= result.data.fileDetails.etag;
														elementData.representations[0].id = result.data.fileDetails.id;
														axios
															.post(
																`${window.CONFIG.SERVICES.cclibrary.melville
																}/${
																	libURN
																}/elements`,
																elementData,
																{headers: header},
															)
															.then(() => {
																resolve();
															})
															.catch((err) => {
																reject(err);
															});
														break;
													}
													else if (result.data.status !== 'VERIFYING') {
														// status came as failed etc.
														reject('Asimov file validation failed');
													}
												}
												if (i === 10) {
													// status is stuck at verifying we wont wait and exit
													reject('Asimov file validation timed out');
												}
											}
										})
										.catch((err) => {
											reject(err);
										});
								})
								.catch((err) => {
									reject(err);
								});
						})
						.catch((err) => {
							reject(err);
						});
				})
				.catch((err) => {
					reject(err);
				});
		});
	};
}

export default new SaveToLibraryManager();
